import React from 'react';
import { Card } from '../components/ui/card';
import { ChefHat } from 'lucide-react';

const Menu = () => {
  const menuCategories = [
    {
      name: 'Hand-Breaded Chicken',
      image: 'https://images.unsplash.com/photo-1694853651800-3e9b4aa96a42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxmcmllZCUyMGNoaWNrZW58ZW58MHx8fHwxNzcyNDgwODc0fDA&ixlib=rb-4.1.0&q=85',
      items: [
        {
          name: 'Krunch Box',
          description: 'includes regular side + biscuit',
          options: [
            { size: '2pc', price: '$7.58' },
            { size: '3pc', price: '$8.99' },
            { size: '4pc', price: '$10.58' }
          ]
        },
        {
          name: 'Chicken + Biscuit',
          options: [
            { size: '2pc', price: '$5.59' },
            { size: '3pc', price: '$7.49' },
            { size: '4pc', price: '$8.99' }
          ]
        }
      ]
    },
    {
      name: 'Hand-Breaded Jumbo Tenders',
      image: 'https://images.unsplash.com/photo-1619019187211-adf2f6119afd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxjaGlja2VuJTIwdGVuZGVyc3xlbnwwfHx8fDE3NzI0ODA4Nzd8MA&ixlib=rb-4.1.0&q=85',
      items: [
        {
          name: 'Krunch Box',
          description: 'includes regular side + biscuit',
          options: [
            { size: '3pc', price: '$7.48' },
            { size: '4pc', price: '$9.28' },
            { size: '6pc', price: '$12.98' }
          ]
        },
        {
          name: 'Tenders + Biscuit',
          options: [
            { size: '3pc', price: '$5.99' },
            { size: '4pc', price: '$6.99' },
            { size: '6pc', price: '$9.99' }
          ]
        }
      ]
    },
    {
      name: 'Chicken Nuggets',
      image: 'https://images.unsplash.com/photo-1562967916-eb82221dfb92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxmcmllZCUyMGNoaWNrZW58ZW58MHx8fHwxNzcyNDgwODc0fDA&ixlib=rb-4.1.0&q=85',
      items: [
        {
          name: 'Krunch Box',
          description: 'includes regular side + biscuit',
          options: [
            { size: '6pc', price: '$6.99' },
            { size: '10pc', price: '$8.99' }
          ]
        },
        {
          name: 'Nuggets + Biscuit',
          options: [
            { size: '6pc', price: '$5.49' },
            { size: '10pc', price: '$7.49' }
          ]
        }
      ]
    },
    {
      name: 'Cajun Chicken Sandwich',
      image: 'https://images.unsplash.com/photo-1703219342329-fce8488cf443?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxjaGlja2VuJTIwc2FuZHdpY2h8ZW58MHx8fHwxNzcyNDgwODg1fDA&ixlib=rb-4.1.0&q=85',
      items: [
        {
          name: 'Krunch Box',
          options: [{ size: '', price: '$6.49' }]
        },
        {
          name: 'Sandwich Only',
          options: [{ size: '', price: '$4.99' }]
        }
      ]
    },
    {
      name: 'Wings',
      description: 'Flavors: Krispy, Buffalo, Sweet & Sour',
      image: 'https://images.unsplash.com/photo-1650939986300-ce9609921fa7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxjaGlja2VuJTIwd2luZ3N8ZW58MHx8fHwxNzcyNDgwODgxfDA&ixlib=rb-4.1.0&q=85',
      items: [
        {
          name: 'Wings',
          options: [
            { size: '5pc', price: '$4.99' },
            { size: '10pc', price: '$9.99' },
            { size: '20pc', price: '$18.99' }
          ]
        }
      ]
    },
    {
      name: 'Shrimp',
      image: 'https://images.unsplash.com/photo-1553557202-e8e60357f061?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxmcmllZCUyMHNocmltcHxlbnwwfHx8fDE3NzI0ODA4ODl8MA&ixlib=rb-4.1.0&q=85',
      items: [
        {
          name: 'Shrimp',
          options: [
            { size: '5pc', price: '$4.99' },
            { size: '10pc', price: '$7.99' }
          ]
        }
      ]
    }
  ];

  const sides = [
    'Mashed Potatoes & Gravy',
    'Mac & Cheese',
    'Jambalaya',
    'Red Beans & Rice',
    'Wedges (Regular, Large, Family)',
    'Honey Biscuits'
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="section section-blue">
        <div className="container max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div 
            className="w-20 h-20 mx-auto mb-6 rounded-2xl flex items-center justify-center"
            style={{ backgroundColor: 'var(--marathon-yellow)' }}
          >
            <ChefHat size={40} style={{ color: 'var(--gray-900)' }} />
          </div>
          <h1 className="text-5xl md:text-6xl font-black mb-6">Krispy Krunchy Chicken Menu</h1>
          <div className="section-divider" style={{ background: 'linear-gradient(90deg, var(--white) 0%, var(--marathon-red) 50%, var(--white) 100%)' }}></div>
          <p className="text-xl md:text-2xl mt-6" style={{ color: 'rgba(255, 255, 255, 0.95)' }}>
            Fresh, hand-breaded chicken made daily with authentic Cajun flavors
          </p>
        </div>
      </section>

      {/* Menu Categories with Images */}
      <section className="section section-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-16">
            {menuCategories.map((category, categoryIndex) => (
              <div key={categoryIndex}>
                <Card className="elevated-card overflow-hidden">
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
                    {/* Image Side */}
                    <div className="relative h-72 lg:h-auto">
                      <img 
                        src={category.image}
                        alt={category.name}
                        className="w-full h-full object-cover"
                      />
                      <div 
                        className="absolute top-4 left-4 px-4 py-2 rounded-lg"
                        style={{ 
                          background: 'rgba(0, 87, 168, 0.95)',
                          backdropFilter: 'blur(10px)'
                        }}
                      >
                        <span className="text-white font-bold text-sm">FRESH DAILY</span>
                      </div>
                    </div>

                    {/* Menu Side */}
                    <div className="p-8 lg:p-10">
                      <h2 
                        className="text-3xl md:text-4xl font-black mb-3"
                        style={{ color: 'var(--marathon-blue)' }}
                      >
                        {category.name}
                      </h2>
                      <div className="section-divider-left mb-6"></div>
                      
                      {category.description && (
                        <p className="text-base font-semibold mb-6 italic" 
                           style={{ color: 'var(--marathon-red)' }}>
                          {category.description}
                        </p>
                      )}

                      <div className="space-y-6">
                        {category.items.map((item, itemIndex) => (
                          <div key={itemIndex}>
                            <div className="mb-3">
                              <h3 className="text-xl font-bold" style={{ color: 'var(--gray-900)' }}>
                                {item.name}
                              </h3>
                              {item.description && (
                                <p className="text-sm" style={{ color: 'var(--gray-600)' }}>
                                  {item.description}
                                </p>
                              )}
                            </div>
                            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                              {item.options.map((option, optionIndex) => (
                                <div
                                  key={optionIndex}
                                  className="p-3 rounded-lg flex flex-col items-center justify-center"
                                  style={{
                                    backgroundColor: 'var(--gray-100)',
                                    border: '2px solid var(--gray-200)'
                                  }}
                                >
                                  {option.size && (
                                    <span className="text-sm font-semibold mb-1" 
                                          style={{ color: 'var(--gray-700)' }}>
                                      {option.size}
                                    </span>
                                  )}
                                  <span 
                                    className="text-lg font-black"
                                    style={{ color: 'var(--marathon-blue)' }}
                                  >
                                    {option.price}
                                  </span>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sides Section */}
      <section className="section section-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-black mb-4" style={{ color: 'var(--marathon-blue)' }}>
              Individual Sides
            </h2>
            <div className="section-divider"></div>
            <p className="text-lg mt-6" style={{ color: 'var(--gray-700)' }}>
              Complete your meal with our delicious sides
            </p>
          </div>

          <Card className="elevated-card">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
              {/* Image */}
              <div className="relative h-72 lg:h-auto">
                <img 
                  src="https://images.unsplash.com/photo-1701484185547-a71576b65e1a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxtYWMlMjBjaGVlc2V8ZW58MHx8fHwxNzcyNDgwODk3fDA&ixlib=rb-4.1.0&q=85"
                  alt="Restaurant Sides"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Sides List */}
              <div className="p-8 lg:p-10 flex items-center">
                <div className="w-full">
                  <h3 className="text-2xl font-bold mb-6" style={{ color: 'var(--gray-900)' }}>
                    Available Sides:
                  </h3>
                  <div className="grid grid-cols-1 gap-3">
                    {sides.map((side, index) => (
                      <div
                        key={index}
                        className="p-4 rounded-lg flex items-center"
                        style={{
                          backgroundColor: 'var(--gray-50)',
                          border: '2px solid var(--gray-200)'
                        }}
                      >
                        <div 
                          className="w-2 h-2 rounded-full mr-3"
                          style={{ backgroundColor: 'var(--marathon-red)' }}
                        ></div>
                        <span className="text-base font-semibold" style={{ color: 'var(--gray-800)' }}>
                          {side}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Card>

          {/* Disclaimer */}
          <div className="mt-8 text-center">
            <p className="text-sm italic" style={{ color: 'var(--gray-600)' }}>
              * Prices and availability may vary. Please call ahead for large orders.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section section-blue">
        <div className="container max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-black mb-6">Ready to Order?</h2>
          <p className="text-xl mb-8" style={{ color: 'rgba(255, 255, 255, 0.95)' }}>
            Visit us at Hope Tobacco or give us a call for takeout orders.<br />
            <span className="font-bold">704 Main St, Hope, Indiana</span>
          </p>
          <a href="tel:8125465780">
            <button
              className="px-10 py-5 rounded-lg text-lg font-bold"
              style={{
                background: 'linear-gradient(135deg, var(--marathon-red) 0%, var(--marathon-red-light) 100%)',
                color: 'white'
              }}
            >
              Call to Order: (812) 546-5780
            </button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default Menu;
